export default "__VITE_ASSET__ComG6MB6__"